import { Pill } from "src/design-system/Pill";

type FilterPillProps = {
  dataLoc: string;
  isActive: boolean;
  text: string;
  onClick: () => void;
};

const FilterPill: React.FC<FilterPillProps> = ({
  dataLoc,
  isActive,
  text,
  onClick,
}) => (
  <Pill
    dataLoc={dataLoc}
    size="md"
    variant={isActive ? "indigo" : "outlined-white"}
    onClick={isActive ? undefined : onClick}
  >
    <Pill.Text>{text}</Pill.Text>
  </Pill>
);

type Props = {
  workspaces: Array<{ id: string; name: string }>;
  selectedWorkspaceId: string | null;
  onChange: (workspaceId: string | null) => void;
};

export const UsersWorkspaceFilter: React.FC<Props> = ({
  workspaces,
  selectedWorkspaceId,
  onChange,
}) => (
  <div
    className="flex flex-wrap gap-x-2 gap-y-2"
    data-loc="users-workspace-filter"
  >
    <FilterPill
      dataLoc="users-workspace-filter-all"
      isActive={selectedWorkspaceId === null}
      text="All"
      onClick={() => onChange(null)}
    />
    {workspaces.map((workspace) => (
      <FilterPill
        key={workspace.id}
        dataLoc={`users-workspace-filter-${workspace.id}`}
        isActive={selectedWorkspaceId === workspace.id}
        text={workspace.name}
        onClick={() => onChange(workspace.id)}
      />
    ))}
  </div>
);
